<bb-product-summary-details-widget>
  <ng-template bbProductSummaryDetailsHeaderCustomizable
               let-hostRef
               let-item="context">
    <div class="bb-stack bb-block bb-block--xl account-detail__header">
      <h2>
        {{ getProductTitle(item) }}
      </h2>
      <button bbButton
              type="button"
              color="secondary"
              data-role="print"
              class="bb-stack__item"
              buttonSize="md"
              [circle]="true"
              (click)="hostRef.print()">
        <bb-icon-ui name="print"></bb-icon-ui>
        <span class="sr-only"
              data-role="button-print"
              i18n="print button@@product.details.button.print">Print</span>
      </button>
    </div>
  </ng-template>



  <!-- Credit Card -->
  <ng-template bbProductSummaryDetailsCreditCardCustomizable
               let-hostRef
               let-product="context.product">
    <ng-container [ngSwitch]="product.additions.cardTypeCode">
      <bn-account-detail-credit-card-multi [product]="product"
                                           [hostRef]="hostRef"
                                           [productNumberFormat]="productNumberCreditCardFormat"
                                           *ngSwitchCase=" 'M' ">
      </bn-account-detail-credit-card-multi>
      <bn-account-detail-credit-card [product]="product"
                                     [hostRef]="hostRef"
                                     [productNumberFormat]="productNumberCreditCardFormat"
                                     *ngSwitchCase="'T'">
      </bn-account-detail-credit-card>
      <bn-account-detail-credit-card [product]="product"
                                     [hostRef]="hostRef"
                                     [productNumberFormat]="productNumberCreditCardFormat"
                                     *ngSwitchCase="'A'">
      </bn-account-detail-credit-card>
    </ng-container>
  </ng-template>

  <!-- Current Account -->
  <ng-template bbProductSummaryDetailsCurrentAccountCustomizable
  let-hostRef
  let-product="context.product"
  let-productNumberFormat="context.productNumberFormat">
<bn-account-details-current [product]="product"
                   [hostRef]="hostRef"
                   [productNumberFormat]="productNumberCreditCardFormat"
                   [accountName]="selectedAccountName">
</bn-account-details-current>
</ng-template>


  <!-- Saving Account -->
  <ng-template bbProductSummaryDetailsSavingsAccountCustomizable
               let-hostRef
               let-product="context.product"
               let-productNumberFormat="context.productNumberFormat">
    <bn-account-details-current [product]="product"
                                [hostRef]="hostRef"
                                [productNumberFormat]="productNumberCreditCardFormat">
    </bn-account-details-current>
  </ng-template>

  <!-- Certificates Deposit-->
  <ng-template bbProductSummaryDetailsTermDepositCustomizable
               let-hostRef
               let-product="context.product"
               let-productNumberFormat="context.productNumberFormat">
    <bn-account-details-certificates-deposit [product]="product"
                                             [hostRef]="hostRef"
                                             [productNumberFormat]="productNumberCreditCardFormat">
    </bn-account-details-certificates-deposit>
  </ng-template>

  <!-- Loans -->
  <ng-template bbProductSummaryDetailsLoanCustomizable
               let-hostRef
               let-product="context.product"
               let-productNumberFormat="context.productNumberFormat">
    <bn-account-details-loans [product]="product"
                              [hostRef]="hostRef"
                              [productNumberFormat]="productNumberCreditCardFormat">
    </bn-account-details-loans>
  </ng-template>

  <ng-template
  bbProductSummaryDetailsLoadingCustomizable
  let-hostRef>
  <ng-container *ngIf="hostRef.error | async as error; else loading">
    <div class="card">
      <div class="card-body bb-text-align-center ">
        <div>

          <ng-container>
            <div class="bb-state-container banesco-empty-state empty-state-container">
              <div>
                <div class="mb-3 bb-beneficiary-selector-ui__not-found-title empty-state-title"
                     i18n="@@dashboard.empty.state.title">
                  Something went wrong
                </div>
                <div class="empty-state-one"
                     i18n="@@dashboard.empty.state-subtitle-one">
                  Unfortunately, the application is not available now.
                </div>

                <div class="empty-state-two"
                     i18n="@@dashboard.empty.state-subtitle-two">
                  Please try again later or contact us at:
                </div>

                <div class="bank-numbers text-left">
                  <ul>
                    <li>829-893-8200,</li>
                    <li i18n="@@dashboard.empty.number">Dominican Republic free of charges 1-809-200-1101 and,</li>
                    <li i18n="@@dashboard.empty.number.two">Whatsapp 829-647-8100.</li>
                  </ul>
                </div>
              </div>

              <div class="not-found-img"></div>

            </div>

          </ng-container>

          <button i18n="Retry button@transactions.state.error.retry-button"
                  bbButton
                  (click)="hostRef.retry()">Retry</button>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #loading>
    <bb-loading-indicator-ui
      [text]="loadingText"
    ></bb-loading-indicator-ui>
  </ng-template>
</ng-template>

<ng-template
bbProductSummaryDetailsNoAccountSelectedCustomizable>
  <div class="card">
    <div class="bb-text-align-center card">
      <div class="bb-state-container banesco-empty-state">
        <div class="mb-3 bb-beneficiary-selector-ui__not-found-title empty-state-title"
          i18n="@@transactions.state.noProductSelected.title">
          No Product selected
        </div>
        <div class="mb-3"
          i18n="@@transactions.state.noProductSelected.subtitle">
          Please select a product first.
        </div>
        <div class="not-found-img"></div>
      </div>
    </div>
  </div>
</ng-template>

</bb-product-summary-details-widget>

<div style="display: none;">
  <div i18n="@@product.details.loadingAccount">Loading account</div>
</div>
